// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Disclaimer-module__wrapper"};